import { render } from "./FormulaireAssembleeGenerale.vue?vue&type=template&id=65648595&scoped=true&ts=true"
import script from "./FormulaireAssembleeGenerale.vue?vue&type=script&lang=ts"
export * from "./FormulaireAssembleeGenerale.vue?vue&type=script&lang=ts"

import "./FormulaireAssembleeGenerale.vue?vue&type=style&index=0&id=65648595&lang=scss&scoped=true"
import "./FormulaireAssembleeGenerale.vue?vue&type=style&index=1&id=65648595&lang=css"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65648595"]])

export default __exports__